import { render, staticRenderFns } from "./PastProjectListItem.vue?vue&type=template&id=63632441&"
import script from "./PastProjectListItem.vue?vue&type=script&lang=ts&"
export * from "./PastProjectListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63632441')) {
      api.createRecord('63632441', component.options)
    } else {
      api.reload('63632441', component.options)
    }
    module.hot.accept("./PastProjectListItem.vue?vue&type=template&id=63632441&", function () {
      api.rerender('63632441', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/views/admin/organization/past-project/PastProjectListItem.vue"
export default component.exports